import { apiHubBaseUrl, request } from '@/libs/api-request'

export function getData (params, force, cancelToken) {
  const url = apiHubBaseUrl() + '/v1/journeymap/target/get_data'

  const config = {
    method: 'post',
    url,
    data: params,
    cancelToken: cancelToken
  }

  return request(config, force)
}

export function getSeqData (params, force, cancelToken) {
  const url = apiHubBaseUrl() + '/v1/journeymap/target/get_nth_seq_nodes'
  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getRankData (params, force) {
  const url = apiHubBaseUrl() + '/v1/journeymap/target/get_nth_rank_data'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getTargetNodeUsers (params, force) {
  const url = apiHubBaseUrl() + '/v1/journeymap/target/get_node_users'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
